<form
  *ngIf="form"
  [formGroup]="form"
  [attr.aria-label]="labels?.stellar?.registration?.mobileNumber"
  class="phone-number-container"
>
  <div class="phone-number-row">
    <input type="hidden" formControlName="countryDialCode" />

    <div class="custom-phone-country-code-label">{{ phoneFieldConfig?.fieldLabel! }}</div>
    <div class="custom-phone-number-container">
      <mat-form-field class="custom-phone-country-code-container">
        <mat-select
          formControlName="countryCode"
          [panelClass]="'custom-country-dropdown'"
          [panelWidth]="'280px'"
          >
          <mat-select-trigger>
            <div class="custom-mat-select-trigger">
              <span
                *ngIf="form?.controls?.countryCode?.value?.toLowerCase()"
                [attr.class]="
                  'sprite-flag country-code-flag ' +
                  form.controls.countryCode.value?.toLowerCase()
                "
              ></span>
              <span>+ {{ getCountryDialingCode() }}</span>
            </div>
          </mat-select-trigger>
          <mat-option
            *ngFor="let country of countries"
            [value]="country.iso2Code"
          >
            <div>
              <div class="custom-mat-option-country-dropdown">
                <span
                  [attr.class]="'sprite-flag ' + country?.iso2Code?.toLowerCase()"
                ></span>
                <span
                  >+ {{ country.countryDialingCode }} {{ country.name }}</span
                >
              </div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="phone-number-container">
        <input
          matInput
          type="text"
          formControlName="phoneNumber"
          id="phoneNumber"
          mgRestrict="0-9\.\-\s"
          [attr.aria-label]="labels?.stellar?.registration?.mobileNumber"
          onpaste="return false"
        />
        <mat-error *ngIf="form.controls.phoneNumber?.errors?.required">
          {{ labels?.stellar?.registration?.mobileNumber }}
          {{ labels?.stellar?.registration?.errorMsgs.required }}!</mat-error
        >
        <mat-error
          *ngIf="
            form.controls.phoneNumber?.errors?.phoneNumber &&
            !form.controls.phoneNumber?.errors?.required
          "
        >
          {{ labels?.stellar?.registration?.mobileNumber }}
          {{ labels?.stellar?.registration?.errorMsgs.invalid }}!
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
